import { useAppDispatch, useAppSelector } from 'store';
import { useToggleState } from '../../../../shared/hooks';

export const useTasksSort = (queryParams: URLSearchParams) => {
    const [isHovered, toggleHover] = useToggleState();
    const dispatch = useAppDispatch();
    const { isSorted, tabs } = useAppSelector((state) => state.tasksInformationReducer);
    const initialTab = queryParams.get('tab') || 'taskBoard';

    return { isSorted, initialTab, isHovered, toggleHover };
};
